import React from 'react';
import { Shield } from 'lucide-react';
export function Guarantee() {
  return <section className="py-16 px-4 bg-surface2 border-y border-zinc-800" data-id="element-109">
      <div className="max-w-3xl mx-auto text-center" data-id="element-110">
        <div className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-zinc-800 mb-6" data-id="element-111">
          <Shield className="w-10 h-10 text-white" data-id="element-112" />
        </div>

        <h2 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-113">
          GARANTÍA 7 DÍAS — SIN PREGUNTAS
        </h2>

        <div className="text-xl text-zinc-300 space-y-2 mb-8" data-id="element-114">
          <p data-id="element-115">Abrís los tomos. Los usás en clase.</p>
          <p data-id="element-116">Si en 7 días no es lo que esperabas:</p>
          <p className="font-bold text-white text-2xl" data-id="element-117">devolución del 100%</p>
          <p data-id="element-118">sin formularios, sin drama.</p>
        </div>

        <p className="text-sm text-zinc-500 font-medium" data-id="element-119">
          Tasa de devoluciones: menos del 1%.
        </p>
      </div>
    </section>;
}